import React, { useState } from 'react';
import Modal from "react-responsive-modal";
import {getHostApi} from "../../../../utils";
import {getUserId} from "../../MonCompteAction";
import {postUploadRequest} from "../UploadActions.api";
import Icons from "../../Icons";
import {BounceLoader} from "../../BounceLoader";

interface SelectOutlineProcessingProps {
  data: any,
  outlineValue: string,
  isInternalUser: boolean,
  isInternalUserAdmin: boolean,
  onChangeOutlineProcessing: any
}

export const SelectOutlineProcessing = (props: SelectOutlineProcessingProps) => {
  const modifyIsEnabled = props && props.isInternalUserAdmin && props.data.order.StatutCommande != '7' && props.data.order.StatutCommande != '8' && props.data.order.StatutCommande != '9' ;
  const initOutlineValues =  {
    'etendu' : {
      'label' : 'etendu',
      'description' :  'Le visuel supporte un décalage de 0,6mm de la sous-couche de blanc. Méthode recommandée par défaut.'
    },
    'couleurBlanc' : {
      'label' : 'couleurBlanc',
      'description' :  'Contours proche du blanc. Adapté aux textiles blancs.'
    },
    'couleurTextile' : {
      'label' : 'couleurTextile',
      'description' :  'Le visuel ne supporte pas un décalage de 0,6mm de la sous-couche de blanc.'
    }
  }

  const [outlineSelected, setOutlineSelected] = useState(props.outlineValue);
  const [canOutlineModify] = useState<boolean>(modifyIsEnabled);
  const [openModale, setOpenModale] = useState<boolean>(false);
  const [waitChange, setWaitChange] = useState<boolean>(false);
  const [msgChange, setMsgChange] = useState<string>('');
  const [msgChangeSuccess, setMsgChangeSucess] = useState<boolean>(false);


  function _onChangeOutlineMod(outlineSelected: string) {
    if(modifyIsEnabled) {
      setWaitChange(true);
      const formData = {
        'gfvId': props.data.originalFileInfos.gfvId,
        'traitementContours': outlineSelected,
        'caddies': _caddiesAndSfcId(props.data.paniers),
        'sfcEmplacementId': props.data.surfaceEmplacementId
      };

      const url = `${getHostApi()}/customers/${getUserId()}/orders/${props.data.order.idCommande}/items/${props.data.paniers[0].idCaddies}/surfaces/${props.data.surface.id}/locations/${props.data.emplacement.id}/images-bat-auto/${props.data.fileRegisteredId}/outline-processing`;

      postUploadRequest(url, formData).then((response: any) => {
        if (response && response.data) {
          setMsgChange('Modification effectuée avec succès');
          setMsgChangeSucess(true);
          props.onChangeOutlineProcessing(true);
        } else {
          props.onChangeOutlineProcessing(true);
          setMsgChange('La modification à échouée');
          setMsgChangeSucess(false);
        }
      }).catch((error) => {
        console.log(error);
        setMsgChange('Une erreur s\'est produite ');
        setMsgChangeSucess(false);
      });
    } else {
      setMsgChange('Modification non autorisée');
      setMsgChangeSucess(false);
    }
  }

  function _resetChangeStatus() {
    setWaitChange(false);
    setMsgChange('');
    setMsgChangeSucess(false);
  }

  function _caddiesAndSfcId(caddies: any) {
    const result = [];
    for (const line of caddies) {
      result.push(line.idCaddies);
    }
    return result;
  }

  const outlineValuesOption  = () => {
    const optionsValues = [];
    const valuesOutline = initOutlineValues;
    for (const [key, value] of Object.entries(valuesOutline)) {
      optionsValues.push(
        <option value={key}>{value.label}</option>
      );
    }
    return optionsValues;
  }

  function _submitOutline(value:any) {
    setMsgChange('');
    setMsgChangeSucess(false);
    setOutlineSelected(value);
    setOpenModale(!openModale);
  }

  function _descriptionContour(contour: string) {
    const valuesOutline = initOutlineValues;
    for (const [key, value] of Object.entries(valuesOutline)) {
      if(contour === key ) {
        return value.description;
      }
    }
  }

  const msgChangeContent = () => {
    const iconType = !msgChangeSuccess ? 'warning' : 'done';
    const colorIcon = !msgChangeSuccess ?  'red' : 'green';
    if(msgChange !== '') {
      return (
        <div className={'text-center py-2'}>
          <Icons icon={iconType} size={20} className={`${colorIcon} mr-1`}/> {msgChange}
          <button className={'ml-2'} onClick={() => [setOpenModale(!openModale), setOutlineSelected(props.outlineValue),_resetChangeStatus()]}>Fermer</button>
        </div>
      );
    } else {
      <BounceLoader id={`outlineChange-${props.data.identifier}`} loading={true} />
    }
  }


  const modaleOutline = () => {
    return (
      <Modal open={openModale} onClose={() => [setOpenModale(!openModale),setOutlineSelected(props.outlineValue),_resetChangeStatus()]} center
             classNames={{overlay: 'bootstrap-container', modal: 'deleteFileModalContainer customModal',
               closeButton: 'deleteFileModalCloseButton closeButton'}}>
        <div className="p-2">
          {!waitChange ? (
            <>
              <p className="text-center font18 bold">&Ecirc;tes-vous sûr de vouloir changer le mode de traitement de contours<br/>
                de <strong>"{props.outlineValue}"</strong> en <strong>"{outlineSelected}"</strong> ?</p>
              <p className={'small grey italic text-center'}>{outlineSelected} : {_descriptionContour(outlineSelected)}</p>
          <button title="Annuler" onClick={() => [setOpenModale(!openModale),setOutlineSelected(props.outlineValue)]}
                  className="border bold bg-white cursor-pointer border-dark btnCancelModal float-left py-2 px-3">
            Non
          </button>
          <button title="Valider le changement de mode de traitement de contours" onClick={(e) => _onChangeOutlineMod(outlineSelected)}
                  className="border-dark border bold bg-white cursor-pointer btnValidateModal float-right py-2 px-3">
            Oui
          </button>
          </>
            ) : (
              <>
            {msgChangeContent()}
            </>
            )}
        </div>
      </Modal>
    );
  };

  return (
    <div className={' my-2 text-center d-flex justify-content-center align-items-center'} >
      <div>Traitement des contours :</div>
        <div className={'d-flex justify-content-center ml-2 align-items-center'}>
        <select disabled={canOutlineModify ? false : true}  value={outlineSelected} onChange={(event) => _submitOutline(event.target.value) }>
          {outlineValuesOption()}
        </select>
        </div>
      {modaleOutline()}
    </div>
  );
}